const vapewholesaleonline = {
    id: 'vapewholesaleonline',
    publicSiteName: 'Vape Wholesale Online',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#22a30e',
            secondary: '#0f0f0f',
            color1: '#0e0e0e',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapewholesaleonline/favicon.ico',
        logo: '/vapewholesaleonline/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vapewholesaleonline